import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../store/auth-contex";
import Loader from "./shared/Loading/Loading";
import DehazeIcon from "@mui/icons-material/Dehaze";
import EastIcon from "@mui/icons-material/East";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import { styled } from "@mui/system";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { toast } from "react-toastify";
import sideNavIcon from "../assets/images/croonus-sidebar-icon.svg";
import logoMediaPrint from "../assets/images/croonus-sidebar-logo-dark.svg";
import { useAppContext } from "../hooks/appContext";
import SystemSelect from "./shared/SystemSwitch/SystemSelect";
import scss from "./UI/ui.module.scss";
import openNewTabImage from "../assets/images/open-new-tab.png";
import aiChatIcon from "../assets/images/ai-chat-icon.png";
import ModalForm from "./shared/Modal/ModalForm";

const Header = ({ openSidenav, isSideNavOpen }) => {

    // TODO: authCtx.user?.user?.role_id == 1 ovo će trebati da se ukine kad AI agent postane svima dostupan

    const { system, setSystem } = useAppContext();
    const apiPath = "admin/profile/logout";
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [link, setLink] = useState(null);

    const [availableSystems, setAvailableSystems] = useState(null);

    const open = Boolean(anchorEl);

    const authCtx = useContext(AuthContext);
    const { api } = authCtx;

    const [openModal, setOpenModal] = useState({ show: false, id: "AIChatModalId" });

    const modalFormChildren = () => {
        // TODO: Potrebno je omogućiti da se preko API-ja dobije link za personalizovanog AI agent po klijentu
        return <>
            <iframe src="https://copilotstudio.microsoft.com/environments/Default-b10b4e39-9f06-4130-961a-234fd8d1a599/bots/crd22_croonusCmsSupportAssistant/webchat?__version__=2frameborder=0" style={{width: "99%", height: "99dvh"}}></iframe>
        </>;
    }

    const aiModalHandler = () => {
        setOpenModal({ ... {show: true}});
    }

    useEffect(() => {
        return () => {
            setIsLoading(false);
        };
    }, []);

    useEffect(() => {
        if (authCtx.isLoggedIn && api?.get && api.user) {
            const updateLink = async () => {
                await api
                    .get(`admin/profile/shop-url/${system?.toLowerCase()}`)
                    .then((response) => {
                        setLink(response.payload);
                    })
                    .catch((error) => {
                        console.warn(error);
                    });
            };

            updateLink();

            const getSystems = async () => {
                await api
                    .get(`admin/options/header/available-systems`)
                    .then((response) => {
                        const available_systems = response?.payload?.available_systems;
                        const default_system = response?.payload?.default_system;

                        const defaultSystem = available_systems.find((system) => system.id === default_system);

                        const croonusAdminSystem = localStorage.getItem("croonusAdminSystem");

                        setSystem(croonusAdminSystem ? croonusAdminSystem : defaultSystem?.name);
                        setAvailableSystems(available_systems);
                    })
                    .catch((error) => {
                        console.warn(error);
                    });
            };
            if (!system) getSystems();
        }
    }, [system, authCtx.isLoggedIn, api?.get, api.user]);

    const logoutHandler = async () => {
        //Uvek mora da izloguje korisnika bez obzira da li je api prosao ili ne
        localStorage.setItem("logoutOnPurpose" , "true")
       
        authCtx.logout();

        setIsLoading(true);
        await api
            .post(apiPath)
            .then(() => {
                toast.success("Uspešno ste se odjavili!");
                navigate(`/`);
                api?.userDataUpdate(null);
                setIsLoading(false);
            })
            .catch((error) => {
                console.warn(error);
                setIsLoading(false);
            });
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const StyledNav = styled(Box)({
        backgroundColor: "var(--bg-color)",
        padding: "0.938rem 2rem",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        "@media print": {
            padding: "0 1rem !important",
        },
        position: "sticky",
        zIndex: "100",
        top: "0",
    });

    return (
        <>
            <StyledNav>
                <Grid container alignItems="center" sx={{ flexWrap: "nowrap" }}>
                    <Box
                        sx={{
                            "@media (min-width: 900px)": {
                                display: "none",
                            },
                        }}
                    >
                        {/* <img src={sideNavIcon} alt="Croonus" width={60} className="sideNavIcon" /> */}
                        <img src={logoMediaPrint} alt="Croonus" width={300} className="mediaPrintLogo" />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "inherit",
                            "@media (max-width: 899px)": {
                                justifyContent: "flex-end",
                            },
                            "@media print": {
                                display: "none",
                            },
                        }}
                    >
                        <Grid
                            item
                            xs={1}
                            sx={{
                                pr: 1,
                                // "@media (max-width: 900px)": {
                                //     order: 1,
                                // },
                                display: "flex",
                                alignItems: "center",
                                marginRight: "auto",
                            }}
                        >
                            {!isSideNavOpen && (
                                <Box>
                                    <img src={sideNavIcon} alt="Croonus" width={60} />
                                </Box>
                            )}
                            <IconButton onClick={openSidenav}>
                                {isSideNavOpen ? (
                                    <DehazeIcon
                                        sx={{
                                            color: "var(--third-color)",
                                            "@media (max-width: 380px)": {
                                                paddingLeft: "10.5rem",
                                            },
                                        }}
                                    />
                                ) : (
                                    <EastIcon sx={{ color: "var(--third-color)" }} />
                                )}
                            </IconButton>
                            <Box sx={{ marginLeft: "24px" }}>
                                <SystemSelect
                                    availableSystems={availableSystems}
                                    onChange={(event) => {
                                        localStorage.setItem("croonusAdminSystem", event.target.value);
                                        setSystem(event.target.value);
                                    }}
                                    value={system}
                                />
                            </Box>
                        </Grid>
                        <Grid container alignItems="center" width="auto" gap={2}>
                            {authCtx.user?.user?.role_id == 1 && (
                                <Grid item>
                                    <IconButton onClick={aiModalHandler} className={scss.primaryIconWrapper}>
                                        <img src={aiChatIcon} alt="AI agent chat" style={{ width: "32px" }} />
                                    </IconButton>
                                </Grid>
                            )}
                            {link && link.status && (
                                <Grid item>
                                    <Link to={link.url} target="_blank" title={link.title} className={scss.primaryIconWrapper}>
                                        <img src={openNewTabImage} alt="open New Tab icon" style={{ width: "24px" }} />
                                    </Link>
                                </Grid>
                            )}
                            <Grid item>
                                <IconButton
                                    onClick={handleClick}
                                    size="small"
                                    sx={{
                                        background: "var(--sidebar-bg-color)",
                                        color: "var(--main-bg-color)",
                                        padding: "0.8rem",
                                        "&:hover": {
                                            backgroundColor: "var(--sidebar-bg-color)",
                                        },
                                    }}
                                    aria-controls={open ? "account-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? "true" : undefined}
                                >
                                    {authCtx.user?.user?.first_name?.charAt(0) + authCtx.user?.user?.last_name?.charAt(0)}
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    id="account-menu"
                                    open={open}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    PaperProps={{
                                        elevation: 0,
                                        sx: {
                                            overflow: "visible",
                                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                            mt: 1.5,
                                            right: "3rem",
                                            left: "auto !important",
                                            top: "3.5rem !important",
                                            "&:before": {
                                                content: '""',
                                                display: "block",
                                                position: "absolute",
                                                top: 0,
                                                right: 14,
                                                width: 10,
                                                height: 10,
                                                bgcolor: "background.paper",
                                                transform: "translateY(-50%) rotate(45deg)",
                                                zIndex: 0,
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem
                                        onClick={() => {
                                            logoutHandler();
                                        }}
                                        sx={{
                                            "&:hover": {
                                                backgroundColor: "inherit",
                                                color: "inherit",
                                            },
                                        }}
                                    >
                                        Odjavite se
                                    </MenuItem>
                                </Menu>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </StyledNav>
            {isLoading && <Loader size={50} />}

            <ModalForm
                modalFormId={`AIChatModalId`}
                children={modalFormChildren()}
                anchor="right"
                openModal={openModal}
                setOpenModal={setOpenModal}
                sx={{ padding: "2rem" }}
                useOnlyCildrenData={true}
            />
        </>
    );
};

export default Header;
